import React, { useRef } from "react";
import Slider from "react-slick";
import Icons from "../../myIcon/Icons";

export default function RishTestimonial({ testimonialData= [], showHeading = true }) {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 1500,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: true,
        cssEase: "ease",
    };

    const CustomArrows = () => (
        <>
            <div className="testimonial-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
                <Icons name="Longarrow_left" />
            </div>
            <div className="testimonial-arrowright" onClick={() => sliderRef.current.slickNext()}>
                <Icons name="Longarrow_right" />
            </div>
        </>
    );

    return (
        <>
            <section className="testimonial">
                <div className="container">
                    <div className="row justify-content-center">

                        <div className="col-lg-10">
                            {showHeading && (
                                <h4 className="heading center-heading">Moments Shared By Guests</h4>
                            )}

                            <div className={`testimonial-slider ${!showHeading ? "no-margin" : ""}`}>
                                <Slider {...settings} ref={sliderRef}>
                                    {testimonialData.map((item, index) => (
                                        <div className="testimonial-box" key={index}>
                                            <p><img src="/image/quote.webp" loading="lazy"alt="quote"/> {item.text} <img src="/image/quote.webp" loading="lazy" alt="quote"/>
                                            </p>

                                            <img src={item.image} className="client-image" loading="lazy" alt={item.name}/>
                                            <span>{item.name}</span>
                                            <small>{item.designation}</small>
                                        </div>
                                    ))}
                                </Slider>
                                <CustomArrows />
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}
